import React, { useState, useEffect } from 'react';
import { withRouter, router } from 'umi';
import { connect, Dispatch } from 'dva';
import styles from './index.less';
import Icon from '@/components/Icon';
import { getQueryString, unionFlag, getLocalStorage, getSessonStorage, getCookie, checkUnifyShop } from '@/utils/index';
import useEventListener from '@/hooks/useEventListener';
import { BFD_checkApp } from '@/utils/bfdApp';
import { checkXcx } from '@/utils/checkXcx';
import { getCityPinyin } from '@/utils/other';
import homeReq from '@/entity/module/home/homeAPi';
import { message } from 'antd';
import { TLang } from '@/utils/lang';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { safeJsonParse } from '@/utils/safeJsonParse';
// interface INavBar {
//   showBack?:boolean,
//   bannerImg?:string,
//   name?:string,
//   text?:string,
//   textStyles?:React.CSSProperties,
//   showSearch?:boolean,
//   showService?: boolean,
//   targetBgColor?:string,
//   initColor?:string,
//   targetColor?:string,
//   opacity?:number // 初始opacity， 1 则不会颜色变化
//   backAction?:()=>void,
//   dispatch?: Dispatch,
//   showMenu?:boolean,
//   isShowMenu?:boolean,
//   showBottom?:boolean
//   // 内置 返回、选择城市、打开客服、打开抽屉
// }


const NavBar = (props: any) => {
  const {
    showBack = true,
    bannerImg = '',
    name = '',
    text = '',
    textStyles = {},
    showSearch = false,
    showService = false,
    initColor = '', // 初始颜色
    targetColor = '',
    targetBgColor = '', // 目标背景颜色,
    dispatch,
    showMenu,
    isShowMenu = false,
    showBottom = false,
    menus
  } = props;
  const df_lang = getCookie('df_lang');

  const [revertColor, setRevertColor] = useState(initColor); // 初始颜色。当滑动，
  const [revertBgColor, setRevertBgColor] = useState(targetBgColor); // 初始颜色。当滑动，
  const [revertOpacity, setRevertOpacity] = useState(props.opacity); // 初始颜色。当滑动，

  // const [orderTypes, setOrderTypes] = useState(defaultOrderTypes);
  const [isShowOrderTypes, setIsShowOrderTypes] = useState(false);
  const scrollHandler = function () {
    // 此处不适合做节流处理，否则 滚动后导航颜色变化之后滞后
    const scrollDom: any = document.querySelector('.am-drawer-content');
    const scrollTop = scrollDom?.scrollTop;
    if (scrollTop > 0 && revertColor === initColor && initColor !== targetColor) {
      setRevertColor(targetColor);
    } else if (scrollTop === 0 && revertColor !== initColor) {
      setRevertColor(initColor);
    }
    let a = scrollTop / 300;
    if (a == 0 && props.opacity !== 1) {
      setRevertOpacity(1);
      setRevertBgColor('');
    } else if (a < 1 && props.opacity !== 1) { // change
      setRevertOpacity(a);
      setRevertBgColor(targetBgColor);
    } else if (a >= 1 && props.opacity !== 1) { // change
      setRevertOpacity(1);
      setRevertBgColor(targetBgColor);
    }
  };
  // useEffect(()=>{
  //   if(isShowMenu){
  //     // 百福得 请求 menu list
  //     const uion = unionFlag() || sessionStorage.getItem('dffl_union');
  //     console.log('request menu list')
  //     if(!uion || uion === 'null'){
  //       return
  //     }
  //     Api.GetOrderMenuList({
  //       union: uion,
  //       city: Number(getQueryString('city')),
  //       platform: 1,
  //       unionFlag: 1,
  //     }).then(res=>{

  //       if (res && res.menuItems) {
  //         const ShoppingItem = res.menuItems.filter(
  //           (item) => item.code === 'order',
  //         )[0];
  //         const tempList = res.menuItems.filter((item) => item.code !== 'order');
  //         tempList.unshift(ShoppingItem);
  //         const orderTypes = tempList.map((item) => ({
  //           title: item.name,
  //           link: item.url,
  //         }));
  //         setOrderTypes(orderTypes)
  //       }
  //     })

  //   }
  // },[isShowMenu])
  useEffect(() => {

    scrollHandler();
  }, []);
  const scrollDom: any = document.querySelector('.am-drawer-content');
  useEventListener('scroll', scrollHandler, scrollDom);
  const handleOpenSearch = () => {
    const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
    const currentAddress = localAddress || JSON.parse(getSessonStorage('currentAddress') || '');
    // search service
    let ms_url = '//'
      + window.location.host.replace('corp.', '').replace('.test05', '-test05')
      + '/ms/?city='
      + currentAddress?.cityId
      + '&return_url='
      + encodeURIComponent(window.location.href);
    const union = unionFlag() || getSessonStorage('dffl_union');
    if (union) {
      ms_url = ms_url + '&union=' + union;
    }
    window.df_sdk_common.location.href = ms_url;
  };
  const handleOpenService = () => {
    //  service
    // eslint-disable-next-line
    window.qimoChatClick()
  };
  const handleBack = () => {
    if (showBack && props.backAction) {
      props.backAction();
    } else {
      router.go(-1);
    }
  };
  const showMenuHandle = () => {
    try {
      const _win: any = window;
      const _menus = _win.loadMenus('', false);
      const union = unionFlag() || sessionStorage.getItem('dffl_union') || sessionStorage.getItem('film_dffl_union');
      if (union || checkUnifyShop()) {
        homeReq.getMenuList()?.then((res) => {
          if (res?.menuItems?.mallChannelList) {
            const unionMenus = res?.menuItems?.mallChannelList?.map((item) => ({
              label: item.name,
              key: item.code.toLocaleLowerCase(),
              url: item.url,
              icon: item.h5ImagePath || ''
            }));
            const bfdMenus = [
              {
                key: 'home',
                label: TLang('商城首页', 'home', false, false, null),
                icon: '',
                url: menus.h5HomeIndex
              }, {
                key: 'center',
                label: TLang('个人中心', 'home', false, false, null),
                icon: '',
                url: menus.h5UserCenter
              }
            ];
            _win.createMenu(bfdMenus, unionMenus);
          }
        });

      } else {
        _win.createMenu(_menus.mainMenus, _menus.menus);
      }
    } catch (e) {
      message.info('页面正在初始化中');
    }
  };
  const isApp = BFD_checkApp();
  const union = unionFlag() || getSessonStorage('dffl_union');
  // TODO: 根据浙商union判断是否展示，浙商小程序添加汉堡包按钮
  const isXcx = checkXcx() && union !== 'ejyshop';
  const orderListFilterEl = () => (
    <div>
      {/* <Modal    百福德 暂时不考虑
          popup
          visible={isShowOrderTypes}
          onClose={()=>setIsShowOrderTypes(false)}
          animationType="slide-down"
          afterClose={() => { alert('afterClose'); }}
        >
          <div className={styles.nav_down_menu}>
            {
              orderTypes.map((item, index) => (
                <div className={styles.item_wrap} key={index} data-set={index} id={index} onClick={()=>{console.log('click...')}}>
                  <div className={`${styles.item} ${index===0?styles.item_active:''}`}>{item.title}</div>
                </div>
              ))
            }
          </div>
        </Modal> */}
    </div>
  );
  // index === 0 ? 'item item-active' : 'item'
  return (
    <>
      <div className={`${styles.topBarContainer} ${showBottom ? styles.hasBottom : ''} navBarContainer`} style={{ 'opacity': revertOpacity, backgroundColor: revertBgColor }}>
        <div className={styles.left}>
          {(showBack && !isApp && !isXcx) ? <div>
            <Icon key="0"
              type="pdp_head_back"
              size="md"
              style={{ 'color': revertColor }}
              clickEvent={handleBack}
            />
          </div> : null}
          {
            bannerImg ? <img src="//static.dongfangfuli.com/h5/img/index_2020/logo.png?v=1598065136" alt="" /> : null
          }
          {
            name ? <div className={styles.cityWrapper}>{df_lang && df_lang == 'en-US' ? getCityPinyin(props.name || '上海市') : (props.name || '上海市')}
              <div className={styles.rotateDown}>
                <Icon key="1"
                  type="order_selectdate_more"
                  size="xxs"
                  style={{ 'color': revertColor }}
                  clickEvent={() => { }}
                />
              </div>
            </div> : null
          }
        </div>
        <div className={styles.center} style={{ marginLeft: showSearch || showService ? '0.8rem' : '0', 'color': revertColor, ...textStyles }}>
          {text ? text : ''}</div>
        {/* {
        isShowMenu?
        <div className={styles.center} style={{marginLeft:showSearch||showService?'0.8rem':'0','color':revertColor}}>
          <span onClick={()=>setIsShowOrderTypes(true)}>{orderTypes[0].title}</span>
          <span></span>
        </div>
        :
      } */}
        <div className={styles.right}>
          {
            showSearch ? <div className={styles.rightItem}>
              <Icon key="2"
                type="search"
                size="xs"
                style={{ 'color': revertColor }}
                clickEvent={() => handleOpenSearch()}
              />
            </div> : null
          }
          {
            showService ? <div className={styles.rightItem}>
              <Icon key="3"
                type="head_service"
                size="md"
                style={{ 'color': revertColor }}
                clickEvent={() => handleOpenService()}
              />
            </div> : null
          }
          {
            (isApp === false && !isXcx && window.location.href.indexOf('newmovie/movieSeat') < 0 && window.location.href.indexOf('order/confirm') < 0) ?
              <div className={styles.rightItem}>
                <Icon key="4"
                  type="pdp_head_morelist"
                  size="md"
                  style={{ 'color': revertColor }}
                  clickEvent={() => showMenuHandle()}
                />
              </div> : null
          }
        </div>

      </div>
      {/* {
      orderListFilterEl()
    } */}
    </>
  );
};
// export default NavBar;
const mapStateToProps = ({ initData }) => ({ ...initData });
export default withRouter(connect(mapStateToProps)(NavBar));

